/* ==========================================================================
   LOYAL · THE SLOT THAT OPENS
   Pairs with sections/loyal-slot-reveal.liquid and loyal-slot-reveal.css.

   THIS SCRIPT'S FIRST JOB IS TO CLOSE THE SLOT, NOT TO OPEN IT.

   That inversion is the whole safety design and it is worth stating plainly,
   because it looks backwards. The CSS ships the section OPEN: window whole,
   planes at zero height, nothing hidden. If this file fails to parse, fails to
   run, or runs in a browser missing IntersectionObserver, the visitor sees the
   section complete. A closed slot that never opens would hide the drop behind
   a door with no handle, and that is the worst failure this section has.

   So: close only after confirming we can open, and open on a timer that fires
   whether or not anything else works.

   ---------------------------------------------------------------------------
   THE TWO MOTIONS, AND THEY OBEY DIFFERENT LAWS ON PURPOSE

   1 · THE DRIFT is a SCRUB. MOTION-SYSTEM section 3: linear, always, tied to
       scroll. The visitor is moving time with their hand. There is no easing,
       no transition and no smoothing on it, because any of those make the page
       disagree with the wheel and read as input lag rather than as design.

   2 · THE OPEN is an ENTRANCE. Expo-out at 900ms, fired once, after
       --dwell-3 = 500ms. Section 2.5: exactly one element per screen gets the
       longest dwell and it is the thing the visitor came for. On the homepage
       that is the drop, so this section spends it and the hero keeps
       --dwell-2.

   Nothing here writes filter, opacity or layout. Transform and height only.
   ========================================================================== */

(function () {
  'use strict';

  var DWELL_3 = 500;      // MOTION-SYSTEM section 2.5. Once per page, maximum.
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.dataset.slotBound === '1') return;
    root.dataset.slotBound = '1';

    var track = root.querySelector('[data-loyal-slot-track]');

    // A visitor who asked for stillness gets the window whole and no suspense.
    // The mechanism IS suspense, so there is no reduced version of it.
    if (reduce.matches) return;

    // No IntersectionObserver means no way to know when to open again, so the
    // slot is never closed. Same reasoning as above: fail open.
    if (!('IntersectionObserver' in window)) return;

    /* ---- 1 · CLOSE, now that we know we can open ---- */
    root.setAttribute('data-slot-state', 'closed');

    /* ---- 2 · THE DRIFT · linear scrub, transform only ---- */
    var drift = parseFloat(getComputedStyle(root).getPropertyValue('--slot-drift')) || 0;
    var ticking = false;

    function scrub() {
      ticking = false;
      if (!track || !drift) return;

      var r = root.getBoundingClientRect();
      var vh = window.innerHeight || 1;

      // 0 as the section's top reaches the bottom of the viewport, 1 as its
      // bottom leaves the top. A pure linear map of scroll position, which is
      // what "scrub is linear" means in practice.
      var p = (vh - r.top) / (vh + r.height);
      if (p < 0) p = 0;
      if (p > 1) p = 1;

      // Centred on the section, so the objects are mid-travel when the slot
      // opens rather than parked at one end of it.
      var x = (0.5 - p) * drift;
      track.style.transform = 'translate3d(' + x.toFixed(3) + '%, 0, 0)';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(scrub);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    scrub();

    /* ---- 3 · THE OPEN · once, on --dwell-3 ---- */
    var opened = false;

    function open() {
      if (opened) return;
      opened = true;
      // The delay IS the anticipation. Section 2.5: "anticipation is expressed
      // in the one dimension that is still free: time before the entrance
      // fires." Not a curve, because a fourth curve is banned.
      setTimeout(function () {
        root.setAttribute('data-slot-state', 'open');
      }, DWELL_3);
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            open();
            io.disconnect();   // once per page load. Never re-arms.
          }
        }
      },
      // Fires when the section is genuinely the thing being looked at rather
      // than when one pixel of it has appeared.
      { threshold: 0.55 }
    );
    io.observe(root);

    /* ---- 4 · THE BACKSTOP, and it is not optional ----
       If the observer never fires because the section is taller than the
       viewport, or the page is restored from bfcache mid-section, the slot
       would stay shut with the drop behind it. This opens it regardless. */
    setTimeout(open, 6000);

    // If the visitor turns reduced motion on mid-session, stop everything and
    // show the window whole.
    reduce.addEventListener('change', function (e) {
      if (!e.matches) return;
      root.setAttribute('data-slot-state', 'open');
      if (track) track.style.transform = '';
    });
  }

  function boot() {
    var all = document.querySelectorAll('[data-loyal-slot]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor re-renders a section with no page load.
  document.addEventListener('shopify:section:load', boot);
})();
